// extracted by mini-css-extract-plugin
export default {"LanguageSelectorFrame":"LanguageButton_LanguageSelectorFrame__YwVQX","title__block":"LanguageButton_title__block__8P4eF","title__text":"LanguageButton_title__text__z1c2r"};